import {
    lazy
} from 'react';

// project imports
import MinimalLayout from '../layout/MinimalLayout';
import Loadable from './../components/Loadable';
import { Navigate } from 'react-router';

// auth routing
const AuthLogin = Loadable(lazy(() => import('../views/login')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: < MinimalLayout />,
    children: [{
        path: '/login',
        element: < AuthLogin />
    }, {
        path: "/",
        element: <Navigate to="/login" />
    }]
};

export default AuthenticationRoutes;